var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStats({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.25C11.5858 2.25 11.25 2.58579 11.25 3V12C11.25 12.4142 11.5858 12.75 12 12.75H21C21.4142 12.75 21.75 12.4142 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25ZM12.75 11.25V3.78363C16.7079 4.14029 19.8597 7.29215 20.2164 11.25H12.75ZM9.28156 4.20815C9.67266 4.07171 9.87911 3.64406 9.74267 3.25296C9.60624 2.86187 9.17859 2.65542 8.78749 2.79185C8.40209 2.9263 8.02776 3.08422 7.66623 3.26389C4.45765 4.85841 2.25 8.17071 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C16.2464 21.75 19.8569 19.0358 21.195 15.2499C21.333 14.8594 21.1284 14.4309 20.7378 14.2929C20.3473 14.1548 19.9188 14.3595 19.7808 14.7501C18.6478 17.9554 15.5909 20.25 12 20.25C7.44365 20.25 3.75 16.5564 3.75 12C3.75 8.76186 5.61547 5.95804 8.33377 4.60716C8.63948 4.45524 8.95589 4.32176 9.28156 4.20815Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.2c038215ddaed3d73d61596f136a255d.svg";
export { ForwardRef as ReactComponent };